import type { LucideIcon } from "lucide-react";
import { Card } from "../../../../components";
import { Col } from "../../../../components/col";
import { Row } from "../../../../components/row";

export interface UserStatisticCard {
  label: string;
  value: number;
  icon: LucideIcon;
  subtitle?: string;
}

interface UserStatisticsCardsProps {
  items: UserStatisticCard[];
}

export function UserStatisticsCards({ items }: UserStatisticsCardsProps) {
  return (
    <Row className="flex overflow-x-auto mb-12">
      {items.map((stat) => (
        <Col key={stat.label} className="flex-1 min-w-[200px]">
          <Card className="p-4 border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-lg h-full">
            <Row className="flex justify-between items-start">
              <span className="font-semibold text-sm text-gray-900 dark:text-gray-100">{stat.label}</span>
              <div className="rounded-lg w-8 h-8 flex items-center justify-center bg-[#F2FCFA] dark:bg-emerald-900/30 dark:border-emerald-700">
                <stat.icon size={16} className="text-emerald-400 dark:text-emerald-400" />
              </div>
            </Row>
            <Row className="block mt-1">
              <span className="text-2xl font-bold text-gray-900 dark:text-gray-100">{stat.value}</span>
              <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">{stat.subtitle || "\u00A0"}</div>
            </Row>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
